import { render, staticRenderFns } from "./FansList.vue?vue&type=template&id=3abf9d99&scoped=true&"
import script from "./FansList.vue?vue&type=script&lang=js&"
export * from "./FansList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3abf9d99",
  null
  
)

export default component.exports